import React from "react";

const bannerStyle = {
  backgroundColor: "#6E260E",
  color: "#fff",
  width: "calc(100% - 2%)",
  padding: "1%",
  fontSize: "1rem",
  fontWeight: "bold",
};
function Banner() {
  return (
    <div style={bannerStyle}>
      New Website Introductory Promo. Up to 35% OFF Discount on our selected
      items.
    </div>
  );
}

export default Banner;
